module.exports = __webpack_public_path__ + "static/media/LY.bea7362c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/LY.svg
// module id = 2201
// module chunks = 7